import { CertificationIcon } from 'foundations-assets/icons/components/CertificationIcon';
import { DiamondIcon } from 'foundations-assets/icons/components/DiamondIcon';
import { FavoriteHollowIcon } from 'foundations-assets/icons/components/FavoriteHollowIcon';
import { TrophyIcon } from 'foundations-assets/icons/components/TrophyIcon';
import unescapedText from 'I18n/utils/unescapedText';
import { useMemo } from 'react';
import { useFilterConfig } from '../filters/hooks/useFilterConfig';

/**
 * @returns `undefined` if `listing` is not a partner
 * @returns `partnerTier` if it exists, otherwise `'none'`
 */
export function getPartnerTier(listing) {
  var _product$partnerTier;
  const product = listing.products[0];
  if ((product === null || product === void 0 ? void 0 : product.productType) !== 'SOLUTIONS_PARTNER_PROFILE') return undefined;
  return (_product$partnerTier = product.partnerTier) !== null && _product$partnerTier !== void 0 ? _product$partnerTier : 'none';
}
export function getPartnerTierContent(tier) {
  switch (tier) {
    case 'elite':
      return {
        badgeUse: 'lorax',
        icon: TrophyIcon,
        text: unescapedText('marketplaceStorefront.partnerTiers.elite')
      };
    case 'diamond':
      return {
        badgeUse: 'blue',
        icon: DiamondIcon,
        text: unescapedText('marketplaceStorefront.partnerTiers.diamond')
      };
    case 'platinum':
      return {
        badgeUse: 'koala',
        icon: CertificationIcon,
        iconColor: 'fill-accent-blue-default',
        text: unescapedText('marketplaceStorefront.partnerTiers.platinum')
      };
    case 'gold':
      return {
        badgeUse: 'koala',
        icon: FavoriteHollowIcon,
        text: unescapedText('marketplaceStorefront.partnerTiers.gold')
      };
    case 'none':
      return {
        badgeUse: 'koala',
        text: unescapedText('marketplaceStorefront.partnerTiers.partner')
      };
    default:
      return undefined;
  }
}
export function usePartnerTierIconMap() {
  const {
    PROFILE_SOLUTIONS_PARTNER_TIER
  } = useFilterConfig();
  return useMemo(() => {
    if (!PROFILE_SOLUTIONS_PARTNER_TIER) return undefined;
    const tiers = PROFILE_SOLUTIONS_PARTNER_TIER.options.map(o => o.value);
    return Object.fromEntries(tiers.map(tier => {
      var _getPartnerTierConten;
      return [tier, (_getPartnerTierConten = getPartnerTierContent(tier)) === null || _getPartnerTierConten === void 0 ? void 0 : _getPartnerTierConten.icon];
    }));
  }, [PROFILE_SOLUTIONS_PARTNER_TIER]);
}